import "./styles.scss";
import { Step } from "@/components/step";
import { useAtomValue, useSetAtom } from "jotai";
import { THEME_CHOICE, themeAtom } from "@/store/themeCustom";
import { RenderChoiceTheme } from "./selectTheme";
import { useTrackAccessSection } from "@/hooks/useTrackAccessSection";

export const NextLevel = () => {
  const themeSelect = useAtomValue(themeAtom);
  const setTheme = useSetAtom(themeAtom);

  useTrackAccessSection(".next_level", "select_theme");

  return (
    <div className="next_level" id="next-level-step-1">
      <div className="next_level__wrapper">
        <div className="next_level__wrapper__step">
          <Step title="1" />
          <div className="next_level__wrapper__step__info">
            <strong>Escolha o tema do seu app</strong>
            <p>
              Selecione o layout que melhor representa a identidade do seu
              provedor. Você pode testar quantos quiser.
            </p>
          </div>
        </div>

        <div className="next_level__wrapper__choice_theme">
          <RenderChoiceTheme
            setTheme={setTheme}
            themeSelect={themeSelect}
            theme={THEME_CHOICE.THEME_DEFAULT}
          />

          <RenderChoiceTheme
            setTheme={setTheme}
            themeSelect={themeSelect}
            theme={THEME_CHOICE.THEME_AMETHYST}
          />
        </div>
      </div>
    </div>
  );
};
